import React from "react";
import SubHeading from "../common/SubHeading";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const yesNoOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" }
];

const LifestyleProfileSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field, isEditMode = true } = useFormSection(props);

  return (
    <section>
      <SubHeading>Lifestyle Profile</SubHeading>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Field
          path="lifestyleProfile.education"
          label="Education"
          type="text"
        />
        <Field
          path="lifestyleProfile.occupation"
          label="Occupation"
          type="text"
        />
        <Field
          path="lifestyleProfile.schedule"
          label="Schedule (shift work/part time)"
          type="text"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <Field
          path="lifestyleProfile.enjoyWork"
          label="Do you enjoy your work?"
          type="radio"
          options={yesNoOptions}
        />
        <Field
          path="lifestyleProfile.satisfiedCompensation"
          label="Are you satisfied / comfortable with your compensation?"
          type="radio"
          options={yesNoOptions}
        />
      </div>
      
      <div className="mt-4">
        <label className="block text-brand-stone-700 mb-2 font-medium">I live with:</label>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <Field
            path="lifestyleProfile.liveWith.myself"
            label="Myself"
            type="checkbox"
          />
          <Field
            path="lifestyleProfile.liveWith.partner"
            label="A partner"
            type="checkbox"
          />
          <Field
            path="lifestyleProfile.liveWith.roommates"
            label="Roommates"
            type="checkbox"
          />
          <Field
            path="lifestyleProfile.liveWith.parents"
            label="Parents"
            type="checkbox"
          />
          <Field
            path="lifestyleProfile.liveWith.children"
            label="Children"
            type="checkbox"
          />
          <div className="flex items-center gap-2">
            <label htmlFor="liveWithOther">Other:</label>
            <Field
              path="lifestyleProfile.liveWith.other"
              type="text"
              render={({ value, onChange }) => (
                <input
                  id="liveWithOther"
                  type="text"
                  value={value || ''}
                  onChange={(e) => onChange(e.target.value)}
                  className="px-2 py-1 border rounded bg-white"
                  disabled={!isEditMode}
                />
              )}
            />
          </div>
        </div>
      </div>
      
      <div className="mt-4">
        <Field
          path="lifestyleProfile.moldExposure"
          label="Have you ever been exposed to mold, live in a home with water damage, live in an old home? Please explain"
          type="textarea"
          rows={3}
        />
      </div>
    </section>
  );
};

export default LifestyleProfileSectionV2;